export default __webpack_public_path__ + "static/media/4.bce28e25.webp";